import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAxios } from "../../utils/useAxios";
import { useAuth } from "@/utils/useAuth";

export async function SendEmailFinishAccount(
  sender: any,
  message: any,
  identifier?: any
) {
  const url = `${endpoints.Gmail}`;

  const data = {
    recipientEmail: "contato@fluxmed.com.br",
    subject: "Solicitação de Backup e Encerramento de Conta Fluxmed",
    body: `<html>
    <head> Identificador: ${identifier} </head>
    
    <body>
    
    </strong> O usuário ${
      sender?.name
    } solicitou o backup e encerramento da conta! </strong>

    <p> ${message || ""} <p>

    <a href=${endpoints.XDSB_domain}/portal> Acessar Fluxmed  </a>
    
    </body>
    
    </html>`,
  };

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 8000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Created) {
        throw new Error(`SendEmail : ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("SendEmail ", error);
      toast.error(`SendEmail Erro: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
